import React from "react";
import {
  Avatar,
  Divider,
  Grid,
  Grow,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Slide,
  Typography,
} from "@material-ui/core";
import { ReactComponent as BG } from "../images/home.svg";
import mnPng from "../images/mn.png";

const about = (aboutData) => (
  <List className="about">
    <Grid container>
      {(aboutData || []).map((el) => {
        el = Object.keys(el)
          .map((k) => ({ [k]: el[k][0] }))
          .reduce((obj, curr) => ({ ...obj, ...curr }));
        return (
          <Grid item key={el.name} xs={el.full ? 12 : 6}>
            <ListItem>
              <ListItemAvatar>
                <>
                  {!el.img && (
                    <Avatar variant="rounded" className="avatar">
                      {el.name[0]}
                    </Avatar>
                  )}
                  {el.img && (
                    <Avatar
                      variant="rounded"
                      className="avatar"
                      src={el.img}
                      alt={el.name}
                    />
                  )}
                </>
              </ListItemAvatar>
              <ListItemText
                className="text"
                primary={
                  <a target="_blank" rel="noopener noreferrer" href={el.url}>
                    {el.name}
                  </a>
                }
                secondary={el.role}
              />
            </ListItem>
            {el.hr && <Divider className="divider" />}
          </Grid>
        );
      })}
    </Grid>
  </List>
);

const contact = (contactData) => (
  <List className="contact">
    {(contactData || []).map((el) => {
      el = Object.keys(el)
        .map((k) => ({ [k]: el[k][0] }))
        .reduce((obj, curr) => ({ ...obj, ...curr }));
      return (
        <ListItem key={el.text}>
          <ListItemAvatar>
            <>
              {!el.imageSrc && (
                <Avatar className="avatar">
                  <i className={`${el.icon} icon`} />
                </Avatar>
              )}
              {el.imageSrc && (
                <Avatar className="avatar" src={el.imageSrc} alt={el.text} />
              )}
            </>
          </ListItemAvatar>
          <ListItemText
            className="text"
            primary={
              <a target="_blank" rel="noopener noreferrer" href={el.textLink}>
                {el.text}
              </a>
            }
            secondary={el.item}
          />
        </ListItem>
      );
    })}
  </List>
);

export default function Home({ data }) {
  return (
    <div id="home">
      <div className="bg">
        <Grow in={true} timeout={2000}>
          <BG />
        </Grow>
      </div>
      <Slide direction="up" in={true} timeout={500}>
        <Typography variant="h1" className="title">
          {data.title}
        </Typography>
      </Slide>
      <Grow timeout={400} in={true}>
        <img className="vector" src={mnPng} alt="" />
      </Grow>
      <div className="staffs">{about(data.staffs[0].member)}</div>
      <div className="contacts">{contact(data.contacts[0].contact)}</div>
    </div>
  );
}
